import { render, staticRenderFns } from "./StepFollowCheck.vue?vue&type=template&id=2e21ecba&scoped=true"
import script from "./StepFollowCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepFollowCheck.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StepFollowCheck.vue?vue&type=style&index=0&id=2e21ecba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21ecba",
  null
  
)

export default component.exports